import React from 'react';

const LoadingScreen = ({ message = 'Loading data...' }) => {
  return (
    <div className="dashboard-loading">
      <div className="loading-orbit">
        <div className="orbit-circle"></div>
        <div className="orbit-circle"></div>
        <div className="orbit-circle"></div>
      </div>
      <div className="loading-text">
        <h3>Loading Dashboard</h3>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
